<template>
  <div>
    <b-row>
      <b-col>
        <div v-show="!hideCompany">
          <b-form-select
            id="Company"
            :options="companyList"
            required
            v-model="filters.company"
          >
          </b-form-select>
        </div>
      </b-col>
      <b-col>
        <div v-show="!hideRegion">
          <b-form-select
            id="Region"
            :options="regionList"
            v-model="filters.region"
          >
          </b-form-select>
        </div>
      </b-col>
      <b-col>
        <div v-show="!hideBranch">
          <b-form-select
            id="Branch"
            :options="branchList"
            v-model="filters.branch"
          >
          </b-form-select>
        </div>
      </b-col>
      <b-col>
        <div v-show="!hidePromotionalInfo">
          <b-form-select
            id="PromotionalInfo"
            :options="promotionalInfoList"
            v-model="filters.promotionalInfo"
          >
          </b-form-select>
        </div>
      </b-col>
      <b-col>
        <div v-show="!hideDevice">
          <b-form-select
            id="Device"
            :options="deviceList"
            v-model="filters.device"
          >
          </b-form-select>
        </div>
      </b-col>
      <b-col>
        <div v-show="!hideDate">
          <div class="datepicker-trigger">
            <button
              class="btn btn-light"
              id="datepicker-trigger"
              style="min-width: 139px"
            >
              {{ formatDates(dateOne, dateTwo) }}
            </button>

            <AirbnbStyleDatepicker
              :trigger-element-id="'datepicker-trigger'"
              :mode="'range'"
              :fullscreen-mobile="true"
              :date-one="dateOne"
              :date-two="dateTwo"
              @date-one-selected="
                val => {
                  dateOne = val;
                }
              "
              @date-two-selected="
                val => {
                  dateTwo = val;
                }
              "
            />
          </div>
          <div>
            <b-form-checkbox v-model="filters.allTime"
              ><div class="text-small-check">All-time</div></b-form-checkbox
            >
          </div>
        </div>
      </b-col>
      <b-col class="text-right">
        <button
          class="btn btn-primary"
          @click="$emit('apply')"
          v-if="!applying"
        >
          Apply
        </button>
        <img
          src="/img/wifi-loading.gif"
          alt="loading"
          class="loading-button-2"
          v-if="applying"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from "axios";
import format from "date-fns/format";
import moment from "moment";
import { promotionalStatusList } from "../../helpers/enums/promotionalStatusEnum";

export default {
  name: "filters",
  props: [
    "filters",
    "applying",
    "hideCompany",
    "hideRegion",
    "hideBranch",
    "hidePromotionalInfo",
    "hideDevice",
    "hideDate",
    "allowAllCompanies"
  ],
  data() {
    return {
      companies: [],
      regions: [],
      branches: [],
      promotionalInfo: [],
      devices: [],
      dateFormat: "D MMM",
      dateOne: "",
      dateTwo: ""
    };
  },
  computed: {
    companyList: function() {
      let companies = [];
      return this.mapLists(
        this.companies,
        this.allowAllCompanies,
        "All Companies"
      );
    },
    regionList: function() {
      return this.mapLists(this.regions, true, "All Regions");
    },
    branchList: function() {
      return this.mapLists(this.branches, true, "All Branches");
    },
    promotionalInfoList: function() {
      return this.mapLists(promotionalStatusList, true, "All Customers");
    },
    deviceList: function() {
      return this.mapLists(this.devices, true, "All Devices");
    },
    currentUser() {
      return this.$store.getters.currentUser;
    }
  },
  methods: {
    mapLists(list, allowAll, defaultText) {
      var listItems = [];
      if (list !== null && list !== undefined) {
        listItems = list.map(item => {
          return {
            text: item.name,
            value: item._id
          };
        });
      }

      if (allowAll) {
        listItems.push({ text: defaultText, value: null });
      }
      return listItems;
    },
    getItems(route) {
      let scope = this;
      return axios.get(process.env.VUE_APP_API + "/" + route, {
        headers: {
          Authorization: "JWT " + scope.$localStorage.get("holly-fi-token")
        }
      });
    },
    getCompanies() {
      this.getItems("company").then(response => {
        this.companies = response.data;
        this.filters.company = this.currentUser.company;
      });
    },
    getRegions() {
      this.getItems(
        `region?where={"company":"${this.filters.company}"}&limit=1000&page=1`
      ).then(response => (this.regions = response.data));
    },
    getBranches() {
      if (this.filters.region !== null) {
        this.getItems(
          `branch?where={"region":"${this.filters.region}"}&limit=1000&page=1`
        ).then(response => (this.branches = response.data.docs));
      }
    },
    getDevices() {
      if (this.filters.branch !== null) {
        this.getItems(
          `device?where={"branch":"${this.filters.branch}"}&limit=1000&page=1`
        ).then(response => (this.devices = response.data));
      }
    },
    formatDates(dateOne, dateTwo) {
      if (dateOne === "" && dateTwo === "") return "Select Date Range";

      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    }
  },
  created() {
    this.dateOne = `${moment().format("YYYY-MM-DD")}`;
    this.dateTwo = `${moment().format("YYYY-MM-DD")}`;
    this.getCompanies();
  },
  watch: {
    "filters.company": {
      immediate: true,
      handler(val, val2) {
        this.getRegions();
        if (val2 !== undefined) {
          this.filters.region = null;
          this.filters.branch = null;
          this.filters.device = null;
        }
      }
    },
    "filters.region"(val, val2) {
      this.getBranches();
      if (val2 !== undefined) {
        this.filters.branch = null;
        this.filters.device = null;
      }
    },
    "filters.branch"(val, val2) {
      this.getDevices();
      if (val2 !== undefined) {
        this.filters.device = null;
      }
    },
    dateOne(val, val2) {
      this.filters.fromDate = this.dateOne;
    },
    dateTwo(val, val2) {
      this.filters.toDate = this.dateTwo;
    }
  }
};
</script>
